<div class="flex flex-col lg:flex-row space-y-2 lg:space-y-0">
    <div
        *ngFor="let menuLink of menuLinks"
        [routerLink]="menuLink.href"
        routerLinkActive="font-black"
        [routerLinkActiveOptions]="{ exact: true }"
        role="button"
        class="cursor-pointer transition-all duration-300 p-4 py-2 hover:font-black"
    >
        <span class="text-sm xl:text-base duration-200">{{menuLink.label}}</span>
    </div>
</div>